import { lightScrollbarStyle } from "../../../../styles/lightScrollbarStyle";

// Following the same Autocomplete styles
export const treeSearchOutlinedInputStyles = {
  borderRadius: "4px",
  p: "6px",
  flexWrap: "wrap",
  paddingRight: "65px",
};

// Following the same Autocomplete styles
export const treeSearchInputAdornmentStyles = {
  position: "absolute",
  right: "9px",
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex",
};

// Following the same Autocomplete styles
export const treeSearchInternalInputStyles = {
  padding: "2.5px 4px 2.5px 8px",
  width: 0,
  minWidth: "100px",
  flexGrow: 1,
  textOverflow: "ellipsis",
};

export const treeSearchInputListboxStyles = {
  maxHeight: 500,
  overflow: "auto",
  width: "100%",
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  ...lightScrollbarStyle,
};

export const treeSearchBaseChipStyles = {
  m: "2px",
  maxWidth: "calc(100% - 4px)",
};

export const treeSearchMoreChipStyles = {
  ...treeSearchBaseChipStyles,
  bgcolor: "primary.light",
  color: "primary.contrastText",
  cursor: "pointer",
  "&:hover": {
    bgcolor: "primary.main",
  },
};
